import React, { useState, useEffect } from "react";
import {
  FaAngleDown,
  FaUser,
} from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { AiOutlineMenu } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";
import { signOut } from "firebase/auth";
import { auth } from "../FirebaseConfig";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const isSmallScreen = useMediaQuery({ maxWidth: "1024px" });

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    console.log("user:", storedUser)
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    }
    setIsClient(true);   
    setLoadingUser(false); 
  }, []);
  

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
  };
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("user");
      setUser(null);
      setIsProfileOpen(false);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  return (
    <>
      <div className="p-1 xl:px-12 px-1 bg-white text-black">
        <div className="container w-full mx-auto flex justify-between items-center">
          <div className="flex md:text-sm text-xs">
            <Link to="/">
              <img
                src={require("../assets/images/logo.jpg")}
                width={80}
                height={80}
                alt="logo"
                className="p-1"
              />
            </Link>
          </div>
          {isClient && isSmallScreen ? (
            <div className="flex items-center pr-4">
              {menuOpen ? (
                <IoCloseSharp
                  onClick={toggleMenu}
                  size={22}
                  className="cursor-pointer"
                />
              ) : (
                <AiOutlineMenu
                  onClick={toggleMenu}
                  size={22}
                  className="cursor-pointer"
                />
              )}
            </div>
          ) : (
            <div className="flex justify-center items-center lg:gap-6 gap-3 large-screen-image">
              <div className="h-16 flex justify-start items-center text-center w-full">
                <Link to="/">
                  <div
                    className="hover:text-logo py-2 rounded-md font-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Home
                  </div>
                </Link>
              </div>
              <div className="h-20 flex justify-start items-center text-center w-full">
                <Link to="/about-us">
                  <div
                    className="hover:text-logo py-2 rounded-md font-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    About Us
                  </div>
                </Link>
              </div>
              <div className="group">
                <div
                  className="flex items-center cursor-pointer py-2"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <span className="font-bold">Our Programs</span>
                  <FaAngleDown size={20} className="ml-1" />
                </div>
                <div className="absolute hidden group-hover:block bg-white text-black shadow-md z-50 p-2 border right-[20%] rounded-md w-[30%]">
                  <Link
                    to="/tech-talent-program"
                    className="block px-2 py-1 hover:bg-gray-100"
                  >
                    <div className="p-2 border rounded-md">
                      <h2 className="font-bold">Talent Hiring Program</h2>
                      <p>
                        Search for individuals to hire staff for your company or
                        project.
                      </p>
                    </div>
                  </Link>
                  <Link
                    to="/digital-skills-program"
                    className="block px-2 py-1 hover:bg-gray-100"
                  >
                    <div className="p-2 border rounded-md">
                      <h2 className="font-bold">Skills Learning Program</h2>
                      <p>
                        Find courses & training programs to learn digital skills
                        online.
                      </p>
                    </div>
                  </Link>
                  <Link
                    to="/services"
                    className="block px-2 py-1 hover:bg-gray-100"
                  >
                    <div className="p-2 border rounded-md">
                      <h2 className="font-bold">
                        Business Development Program
                      </h2>
                      <p>
                        Hire services to boost business sales & presence through
                        a blend of technical strategies.
                      </p>
                    </div>
                  </Link>
                  <Link
                    to="/charity-program"
                    className="block px-2 py-1 hover:bg-gray-100"
                  >
                    <div className="p-2 border rounded-md">
                      <h2 className="font-bold">Charity Program</h2>
                      <p>
                        Contribute to lift up individuals in needs. Be a helping
                        hand.
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              {!loadingUser && !user && (
                <div className="h-20 gap-3 flex justify-start items-center text-center w-full">
                  <Link
                    to="/join-community"
                    className="bg-gradient-to-r hover:bg-gradient-to-r from-black to-logo w-full text-sm from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Join Community
                  </Link>
                </div>
              )}

              <SearchBar />
              {user && (
                <div className="relative z-[999] overflow-visible">
                  <FaUser
                    size={24}
                    className="cursor-pointer text-gray-800 hover:text-logo"
                    onClick={toggleProfile}
                  />
                  {isProfileOpen && (
                    <div className="absolute right-0 mt-2 w-60 bg-white border rounded-md shadow-lg z-[9999]">
                      <div className="p-3">
                        <p className="font-semibold">{user.name || "User"}</p>
                        <p className="text-sm text-gray-600">
                          {user.email || "No email"}
                        </p>{" "}
                      </div>
                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsProfileOpen(false)}
                      >
                        View Profile
                      </Link>
                      <button
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div
        className={`flex bg-gradient-to-r from-black to-logo w-full text-white h-full flex-col absolute transition-all duration-1000 ease-in-out p-3 ${
          menuOpen ? "top-[88px] z-[999]" : "-top-[100%] -z-50"
        }`}
      >
        <div
          className="overflow-x-hidden flex justify-center w-full items-center"
          style={{ whiteSpace: "nowrap" }}
        >
          {isClient && isSmallScreen && (
            <div className="w-full px-3">
              <div className="flex justify-start items-center text-center w-full">
                <Link to="/">
                  <div
                    className="hover:text-logo py-2 rounded-md font-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Home
                  </div>
                </Link>
              </div>
              <div className="flex justify-start items-center text-center w-full">
                <Link to="/about-us">
                  <div
                    className="hover:text-logo mb-2 rounded-md font-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    About Us
                  </div>
                </Link>
              </div>
              <div className="relative font-bold cursor-pointer justify-start items-center w-full">
                <div
                  className="flex justify-between text-white w-full pb-2"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={toggleDropdown}
                >
                  <h2>Our Programs</h2>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out`}
                  style={{ position: "relative", top: "4px", zIndex: 1000 }}
                >
                  <div className="w-full shadow-md text-white rounded-md">
                    <Link
                      to="/tech-talent-program"
                      className="block font-bold px-4 py-2 hover:bg-gray-100"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Talent Hiring Program
                    </Link>
                    <Link
                      to="/digital-skills-program"
                      className="block font-bold px-4 py-2 hover:bg-gray-100"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Skills Learning Program
                    </Link>
                    <Link
                      to="/services"
                      className="block font-bold px-4 py-2 hover:bg-gray-100"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Business Services Program
                    </Link>
                    <Link
                      to="/charity-program"
                      className="block font-bold px-4 py-2 hover:bg-gray-100"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Charity Program
                    </Link>
                  </div>
                </div>
              </div>
              {!loadingUser && !user && (
                <div
                  className={`flex justify-center items-center text-center w-full mb-10 transition-all duration-500 ${
                    isDropdownOpen ? "translate-y-4" : ""
                  }`}
                >
                  <Link to="/join-community">
                    <div
                      className="bg-gradient-to-r w-full hover:bg-gradient-to-r from-black to-logo text-sm from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Join Community
                    </div>
                  </Link>
                </div>
              )}

              <SearchBar />
              {user && (
                <div className="relative mt-4">
                  <FaUser
                    size={24}
                    className="cursor-pointer text-white hover:text-gray-200"
                    onClick={toggleProfile}
                  />
                  {isProfileOpen && (
                    <div className="mt-2 w-60 bg-white border rounded-md shadow-lg z-[999] text-black">
                      <div className="p-3">
                        <p className="font-semibold">{user.name || "User"}</p>
                        <p className="text-sm text-gray-600">
                          {user.email || "No email"}
                        </p>
                      </div>
                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsProfileOpen(false)}
                      >
                        View Profile
                      </Link>
                      <button
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
